module.exports = __webpack_public_path__ + "static/media/mitsubishi-street-selected.f99af71b.svg";